import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { EquipmentCodeQualifierEnum, hasEquipmentCodeQualifier } from '../../store/models';
import { NOT_AVAILABLE, IconNames, MeasurementUnitCodesMap } from '../../common/constants';
import { MeasurementUnitCodesEnum } from '../../common/models';
import { PipesModule } from '../../common/pipes/pipes.module';
import { DirectivesModule } from '../../common/directives/directives.module';
import { WaybillEquipmentItemModel } from '../../store/models/waybill-equipments.model';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { BehaviorSubject } from 'rxjs';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { EquipmentMaterialsComponent } from './equipment-materials/equipment-materials.component';

@Component({
  selector: 'ui-equipments',
  imports: [
    CommonModule,
    TranslateModule,
    PipesModule,
    DirectivesModule,
    MatCardModule,
    MatTableModule,
    SvgIconComponent,
    MatTooltipModule,
    EquipmentMaterialsComponent,
  ],
  templateUrl: './equipments.component.html',
  styleUrls: ['./equipments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class EquipmentsComponent {
  @Input() set equipments(equipments: WaybillEquipmentItemModel[]) {
    if (equipments) {
      this.equipments$.next(equipments);

      if (equipments.some((equipment: WaybillEquipmentItemModel) => !!equipment.materials)) {
        this.columns.push('expand');
      }
    }
  }
  @Input() weightUnitCode: MeasurementUnitCodesEnum | null = null;
  @Input() volumeUnitCode: MeasurementUnitCodesEnum | null = null;
  notAvailable = NOT_AVAILABLE;
  equipmentCodeQualifierEnum = EquipmentCodeQualifierEnum;
  measurementUnitCodes = MeasurementUnitCodesMap;
  iconNames = IconNames;
  expandedMaterialId$: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  equipments$: BehaviorSubject<WaybillEquipmentItemModel[]> = new BehaviorSubject<WaybillEquipmentItemModel[]>([]);
  hasEquipmentCodeQualifier = hasEquipmentCodeQualifier;

  columns: string[] = [
    'equipmentCodeQualifier',
    'id',
    'equipmentType',
    'full',
    'grossWeight',
    'chargeableWeight',
    'volume',
    'sealNumber',
  ];

  protected readonly iconNameList = IconNames;

  expand(id: number, noMaterialsVailable: boolean): void {
    if (noMaterialsVailable) {
      return;
    }

    const value = this.expandedMaterialId$.getValue() === id ? null : id;
    this.expandedMaterialId$.next(value);
  }

  hasMaterials(index: number, row: WaybillEquipmentItemModel): boolean {
    return !!row.materials?.length;
  }
}
